export const cloudPbxPlans = [
  {
    id: "4",
    title: "سالیانه",
    price: "4540000",
    setupFee: "767000",
    label: "بسته برنزی",
    class: "brown",
    options: [
      { id: "1", title: " 5کاربر" },
      { id: "2", title: "1 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "پنل مدیریتی" },
    ],
    // off: 20,
  },
  {
    id: "3",
    title: "سالیانه",
    price: "8960000",
    setupFee: "1157000",
    label: "بسته نقره ای",
    class: "silver",
    options: [
      { id: "1", title: " 10 کاربر" },
      { id: "2", title: "2 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "پنل مدیریتی" },
      { id: "6", title: "قابلیت اتصال به IP-Phone" },
    ],
    // off: 20,
  },
  {
    id: "2",
    title: "سالیانه",
    price: "18100000",
    setupFee: " 1937000",
    label: "بسته طلایی",
    class: "yellow",
    options: [
      { id: "1", title: "20 کاربر " },
      { id: "2", title: "5 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "پنل مدیریتی" },
      { id: "6", title: "قابلیت اتصال به IP-Phone" },
    ],
    // off: 25,
  },
  {
    id: "1",
    title: "سالیانه",
    price: "25870000",
    setupFee: "2587000",
    label: "بسته اپال",
    class: "green",
    options: [
      { id: "1", title: "30کاربر " },
      { id: "2", title: "10 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "پنل مدیریتی" },
      { id: "6", title: "قابلیت اتصال به IP-Phone" },
    ],
    // off: 30,
  },
];

export const callcenterPlans = [
  {
    id: "4",
    title: "سالیانه",
    price: "55760000 ",
    setupFee: "6500000",
    label: "بسته کریپتون",
    options: [
      { id: "1", title: "50 کاربر" },
      { id: "2", title: "20 گیگ فضای ذخیره‌سازی ابری" },
      { id: "4", title: "سرویس وب چت" },
      { id: "5", title: "فکس ابری نواتل" },
      { id: "6", title: "داشبورد مدیریتی" },
    ],
    // off: 30,
  },
  {
    id: "3",
    title: "سالیانه",
    price: "92160000 ",
    setupFee: "9100000",
    label: "بسته کادمیم",
    options: [
      { id: "1", title: " 100 کاربر" },
      { id: "2", title: "35 گیگ فضای ذخیره‌سازی ابری" },
      { id: "4", title: "سرویس وب چت" },
      { id: "5", title: "فکس ابری نواتل" },
      { id: "6", title: "داشبورد مدیریتی" },
    ],
    // off: 30,
  },
  {
    id: "2",
    title: "سالیانه",
    price: "105160000",
    setupFee: "11700000",
    label: "بسته بیسموت",
    options: [
      { id: "1", title: "150 کاربر " },
      { id: "2", title: "50 گیگ فضای ذخیره‌سازی ابری" },
      { id: "4", title: "سرویس وب چت" },
      { id: "5", title: "فکس ابری نواتل" },
      { id: "6", title: "داشبورد مدیریتی" },
    ],
    // off: 30,
  },
  {
    id: "1",
    title: "سالیانه",
    price: "118160000",
    setupFee: "14300000",
    label: "بسته تنگستن",
    class: "green",
    options: [
      { id: "1", title: "200 کاربر " },
      { id: "2", title: "65 گیگ فضای ذخیره‌سازی ابری" },
      { id: "4", title: "سرویس وب چت" },
      { id: "5", title: "فکس ابری نواتل" },
      { id: "6", title: "داشبورد مدیریتی" },
    ],
    // off: 30,
  },
];

export const metamaPlans = [
  {
    id: "3",
    title: "سالیانه",
    price: "8450000",
    setupFee: "2977000",
    label: "بسته برنزی",
    class: "brown",
    options: [
      { id: "1", title: " 5کاربر" },
      { id: "2", title: "1 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "داشبورد مدیریتی" },
    ],
    // off: "10",
  },
  {
    id: "4",
    title: "سالیانه",
    price: "12077000",
    setupFee: "3757000",
    label: "بسته نقره‌ای",
    class: "brown",
    options: [
      { id: "1", title: " 10کاربر" },
      { id: "2", title: "2 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "داشبورد مدیریتی" },
    ],
    // off: "10",
  },
  {
    id: "2",
    title: "سالیانه",
    price: "24310000",
    setupFee: " 4537000",
    label: "بسته طلایی",
    class: "yellow",
    options: [
      { id: "1", title: "20 کاربر " },
      { id: "2", title: "5 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "داشبورد مدیریتی" },
    ],
    // off: "30",
  },
  {
    id: "1",
    title: "سالیانه",
    price: "35230000",
    setupFee: "5187000",
    label: "بسته اپال",
    class: "green",
    options: [
      { id: "1", title: "30کاربر " },
      { id: "2", title: "10 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "داشبورد مدیریتی" },
    ],
    // off: "40",
  },
];

export const roundPlans = [
  {
    id: "4",
    title: "سالیانه",
    price: "6100000",
    setupFee: "767000",
    label: "بسته برنزی",
    class: "brown",
    options: [
      { id: "1", title: " 5کاربر" },
      { id: "2", title: "1 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "پنل مدیریتی" },
    ],
    // off: "20",
  },
  {
    id: "3",
    title: "سالیانه",
    price: "12100000",
    setupFee: "1157000",
    label: "بسته نقره ای",
    class: "silver",
    options: [
      { id: "1", title: " 10 کاربر" },
      { id: "2", title: "2 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "پنل مدیریتی" },
      { id: "6", title: "قابلیت اتصال به IP-Phone" },
    ],
    // off: "20",
  },
  {
    id: "2",
    title: "سالیانه",
    price: "24310000",
    setupFee: " 1937000",
    label: "بسته طلایی",
    class: "yellow",
    options: [
      { id: "1", title: "20 کاربر " },
      { id: "2", title: "5 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "پنل مدیریتی" },
      { id: "6", title: "قابلیت اتصال به IP-Phone" },
    ],
    // off: "25",
  },
  {
    id: "1",
    title: "سالیانه",
    price: "35230000",
    setupFee: "2587000",
    label: "بسته اپال",
    class: "green",
    options: [
      { id: "1", title: "30کاربر " },
      { id: "2", title: "10 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "پنل مدیریتی" },
      { id: "6", title: "قابلیت اتصال به IP-Phone" },
    ],
    // off: "30",
  },
];

export const faxPlans = [
  {
    id: "4",
    title: "سالیانه",
    price: "2730000",
    label: "بسته برنزی",
    class: "brown",
    options: [
      { id: "1", title: "مبلغ سالیانه برای ارسال و دریافت فکس نامحدود" },
      { id: "2", title: "دریافت فکس از طریق ایمیل" },
      { id: "3", title: "دریافت فکس بر روی اپلیکیشن موبایل (اپلیکیشن نواتل)" },
      { id: "4", title: "دریافت فکس از طریق وب‌سرویس نواتل" },
    ],
    // off: 10,
  },
  {
    id: "3",
    title: "سالیانه",
    price: "2990000",
    label: "بسته نقره ای",
    class: "silver",
    options: [
      { id: "1", title: "مبلغ سالیانه برای ارسال و دریافت فکس نامحدود" },
      { id: "2", title: "دریافت فکس از طریق ایمیل" },
      { id: "3", title: "دریافت فکس بر روی اپلیکیشن موبایل (اپلیکیشن نواتل)" },
      { id: "4", title: "دریافت فکس از طریق وب‌سرویس نواتل" },
    ],
    // off: 10,
  },
  {
    id: "2",
    title: "سالیانه",
    price: "3120000",
    label: "بسته طلایی",
    class: "yellow",
    options: [
      { id: "1", title: "مبلغ سالیانه برای ارسال و دریافت فکس نامحدود" },
      { id: "2", title: "دریافت فکس از طریق ایمیل" },
      { id: "3", title: "دریافت فکس بر روی اپلیکیشن موبایل (اپلیکیشن نواتل)" },
      { id: "4", title: "دریافت فکس از طریق وب‌سرویس نواتل" },
    ],
    // off: 10,
  },
  {
    id: "1",
    title: "سالیانه",
    price: "3380000",
    label: "بسته اپال",
    class: "green",
    options: [
      { id: "1", title: "مبلغ سالیانه برای ارسال و دریافت فکس نامحدود" },
      { id: "2", title: "دریافت فکس از طریق ایمیل" },
      { id: "3", title: "دریافت فکس بر روی اپلیکیشن موبایل (اپلیکیشن نواتل)" },
      { id: "4", title: "دریافت فکس از طریق وب‌سرویس نواتل" },
    ],
    // off: 10,
  },
];

export const crmPlans = [
  {
    id: "4",
    title: "سالیانه",
    price: "5460000",
    label: "بسته برنزی",
    class: "brown",
    options: [
      { id: "1", title: "5 کاربر" },
      { id: "2", title: "امکان ایجاد 1000 پروفایل" },
      { id: "3", title: "1 گیگ فضای ذخیره‌سازی ابری" },
      { id: "4", title: "پشتیبانی ۲۴×۷" },
      { id: "5", title: "قابلیت تماس مستقیم" },
      { id: "6", title: "پاپ اپ تماس" },
    ],
    // off: 30,
  },
  {
    id: "3",
    title: "سالیانه",
    price: "9360000",
    label: "بسته نقره ای",
    class: "silver",
    options: [
      { id: "1", title: "10 کاربر" },
      { id: "2", title: "امکان ایجاد 2000 پروفایل" },
      { id: "3", title: "2 گیگ فضای ذخیره‌سازی ابری" },
      { id: "4", title: "پشتیبانی ۲۴×۷" },
      { id: "5", title: "قابلیت تماس مستقیم" },
      { id: "6", title: "پاپ اپ تماس" },
    ],
    // off: 30,
  },
  {
    id: "2",
    title: "سالیانه",
    price: "14100000",
    label: "بسته طلایی",
    class: "yellow",
    options: [
      { id: "1", title: "20 کاربر" },
      { id: "2", title: "امکان ایجاد 4000 پروفایل" },
      { id: "3", title: "5 گیگ فضای ذخیره‌سازی ابری" },
      { id: "4", title: "پشتیبانی ۲۴×۷" },
      { id: "5", title: "قابلیت تماس مستقیم" },
      { id: "6", title: "پاپ اپ تماس" },
    ],
    // off: 30,
  },
  {
    id: "1",
    title: "سالیانه",
    price: "16380000",
    label: "بسته اپال",
    class: "green",
    options: [
      { id: "1", title: "30 کاربر" },
      { id: "2", title: "امکان ایجاد 6000 پروفایل" },
      { id: "3", title: "10 گیگ فضای ذخیره‌سازی ابری" },
      { id: "4", title: "پشتیبانی ۲۴×۷" },
      { id: "5", title: "قابلیت تماس مستقیم" },
      { id: "6", title: "پاپ اپ تماس" },
    ],
    // off: 30,
  },
];

export const smsPlans = [
  {
    id: "4",
    title: "سالیانه",
    price: "1300000",
    label: "بسته برنزی",
    class: "brown",
    options: [
      { id: "7", title: "5 کاربر" },
      { id: "1", title: "100 پیامک رایگان شارژ هدیه " },
      { id: "2", title: "ارسال تکی،گروهی و انبوه" },
      { id: "3", title: "ارسال زماندار و هوشمند" },
      { id: "4", title: "گزارش ارسال و دریافت" },
      { id: "5", title: "ایجاد گروه و لیست مخاطبین" },
      { id: "6", title: "ساخت پیام‌های پیش فرض" },
    ],
    // off: "20",
  },
  {
    id: "3",
    title: "سالیانه",
    price: "1950000",
    label: "بسته نقره‌ای",
    class: "silver",
    options: [
      { id: "7", title: "10 کاربر" },
      { id: "1", title: "200 پیامک رایگان شارژ هدیه " },
      { id: "2", title: "ارسال تکی،گروهی و انبوه" },
      { id: "3", title: "ارسال زماندار و هوشمند" },
      { id: "4", title: "گزارش ارسال و دریافت" },
      { id: "5", title: "ایجاد گروه و لیست مخاطبین" },
      { id: "6", title: "ساخت پیام‌های پیش فرض" },
    ],
    // off: "20",
  },
  {
    id: "2",
    title: "سالیانه",
    price: "2600000",
    label: "بسته طلایی",
    class: "yellow",
    options: [
      { id: "7", title: "20 کاربر" },
      { id: "1", title: "300 پیامک رایگان شارژ هدیه " },
      { id: "2", title: "ارسال تکی،گروهی و انبوه" },
      { id: "3", title: "ارسال زماندار و هوشمند" },
      { id: "4", title: "گزارش ارسال و دریافت" },
      { id: "5", title: "ایجاد گروه و لیست مخاطبین" },
      { id: "6", title: "ساخت پیام‌های پیش فرض" },
    ],
    // off: "20",
  },
  {
    id: "1",
    title: "سالیانه",
    price: "3250000",
    label: "بسته اپال",
    class: "green",
    options: [
      { id: "7", title: "30 کاربر" },
      { id: "1", title: "400 پیامک رایگان شارژ هدیه " },
      { id: "2", title: "ارسال تکی،گروهی و انبوه" },
      { id: "3", title: "ارسال زماندار و هوشمند" },
      { id: "4", title: "گزارش ارسال و دریافت" },
      { id: "5", title: "ایجاد گروه و لیست مخاطبین" },
      { id: "6", title: "ساخت پیام‌های پیش فرض" },
    ],
    // off: "20",
  },
];